import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as css from './TransactionTop.css';
import {RootState} from '../../../../redux/store.type';

function TransactionTop() {
    const {t} = useTranslation('eTicket');
    const order = useSelector((state: RootState) => state.eTicket.data?.order);
    return (
        <css.transactionTop data-cy="transaction-top">
            <css.transactionTopTitle>{t('tabTransaction')}</css.transactionTopTitle>
            {order?.oid && (
                <css.orderNumber>
                    {t('transactionNumber', {oid: order.oid})}
                </css.orderNumber>
            )}
        </css.transactionTop>
    );
}

export default TransactionTop;
